'use client';

import { useState } from 'react';
import { AppDownloadModal } from '@components/AppDownloadModal/AppDownloadModal';
import { FAQ } from '@components/FAQ/FAQ';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { CountryDetailFields } from '@generated/graphql';
import { getFAQData } from './helpers/getFAQData';
import { IRecentCatchesSummary } from './helpers/buildRecentCatchesSummary';

interface IProps {
  className?: string;
  country: CountryDetailFields | null;
  topSpecies?: { _id: string; displayName: string; url: string }[];
  topFishingWaters?: { _id: string; displayName: string }[];
  topStatesByCatches?: { stateId: string; stateName: string; totalCatchesThisYear: string }[];
  recentCatchesSummary?: IRecentCatchesSummary;
  hasRegulations?: boolean;
  title?: string;
  id?: string;
}

export const FAQSection = ({
  className,
  country,
  topFishingWaters,
  topSpecies,
  topStatesByCatches,
  recentCatchesSummary,
  hasRegulations,
  title,
  id,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: country?.id ?? undefined,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    country,
    handleCTAClick,
    topSpecies,
    topFishingWaters,
    topStatesByCatches,
    recentCatchesSummary,
    hasRegulations,
  });

  if (faqData.length === 0) {
    return null;
  }

  return (
    <FAQ
      className={className}
      faqData={faqData}
      headingVariant="sm"
      showFAQMetaData
      id={id}
      title={title}
    >
      <AppDownloadModal
        appDownloadSourceId={country?.id ?? undefined}
        appDownloadSource="FAQSection"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
